import React from "react";

//todo(jsimms): move to icon assets directory and regenerate using the icon script
export const UGGLogoFull = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 240 78" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="UGG_Logo_White Copy 3">
        <path
          id="Path"
          d="M77.4658 75.8343C75.5093 73.8382 75.2335 70.7387 76.8069 68.4285C78.3802 66.1183 81.3653 65.2396 83.9394 66.3289C86.5135 67.4183 87.961 70.1729 87.398 72.9106C86.835 75.6484 84.4181 77.6083 81.623 77.5936C80.0529 77.6111 78.5464 76.9736 77.4658 75.8343Z"
          fill="#3273FA"
        />
        <path
          id="Path_2"
          d="M164.211 28.2762V27.9526C164.211 14.7311 157.446 8.1203 143.918 8.1203H125.857C112.328 8.1203 105.564 14.7311 105.564 27.9526V57.7482C105.564 70.9787 112.328 77.594 125.857 77.594H143.877C157.406 77.594 164.17 70.9787 164.17 57.7482V41.4617H137.072L132.364 51.7756H152.657V57.7482C152.657 64.1837 149.753 67.397 143.945 67.388H125.857C120.04 67.388 117.131 64.1747 117.131 57.7482V27.9661C117.131 21.5486 120.04 18.3398 125.857 18.3398H143.877C149.685 18.3398 152.589 21.5486 152.589 27.9661V33.3589L164.211 28.2762Z"
          fill="white"
        />
        <path
          id="Path_3"
          d="M240 28.2762V27.9526C240 14.7311 233.237 8.1203 219.712 8.1203H201.642C188.116 8.1203 181.353 14.7311 181.353 27.9526V57.7482C181.353 70.9787 188.116 77.594 201.642 77.594H219.658C233.183 77.594 239.946 70.9787 239.946 57.7482V41.4617H212.868L208.161 51.7756H228.449V57.7482C228.449 64.1837 225.541 67.397 219.725 67.388H201.642C195.835 67.388 192.931 64.1747 192.931 57.7482V27.9661C192.931 21.5486 195.835 18.3398 201.642 18.3398H219.658C225.474 18.3398 228.382 21.5486 228.382 27.9661V33.3589L240 28.2762Z"
          fill="white"
        />
        <path
          id="Path_4"
          d="M45.8503 7.21805V61.1484C40.7023 64.1138 34.8638 65.6926 28.9126 65.7285C22.9428 65.7044 17.0839 64.1251 11.9211 61.1484V7.21805L0 12.441V67.6302L2.69707 69.4381C10.4204 74.673 19.5353 77.5116 28.8857 77.594C38.2268 77.5063 47.3316 74.6679 55.0473 69.4381L57.7444 67.6838V12.441L45.8503 7.21805Z"
          fill="white"
        />
        <path
          id="Path_5"
          d="M28.3878 0L22.5564 2.69844V41.556C24.4602 42.1166 26.4322 42.4028 28.4144 42.406C30.401 42.4028 32.3773 42.1167 34.2857 41.556V2.69844L28.3878 0Z"
          fill="#3273FA"
        />
      </g>
    </svg>
  );
};
